<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Upload Pros'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <tidy-row [alignLastItemRight]="true">
        <tidy-image
          [src]="'assets/img/csv.svg'"
          class="title-size" />
        <tidy-text
          [header]="'Import CSV'" />
        <tidy-text
          (action)="openFilePicker()"
          [body]="'Select File'"
          class="link" />
      </tidy-row>
    </tidy-card>

    <tidy-button
      [text]="'Upload Pros'"
      class="primary"
      [action]="boundUploadPros" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
